import { supabaseClient } from '@/utils/supabase-client';

export const teamApi = {
  /**
   * Get organization members
   */
  getOrganizationMembers: (organizationId: string) => {
    return supabaseClient
      .from('organisation_member')
      .select('*, user(*)')
      .eq('organisation_id', organizationId);
  },

  /**
   * Get organization invites
   */
  getOrganizationInvites: (organizationId: string) => {
    return supabaseClient
      .from('organisation_invite')
      .select('*')
      .eq('organisation_id', organizationId)
      .order('created_at', { ascending: false });
  },

  /**
   * Get user invites
   */
  getUserInvites: (email: string) => {
    return supabaseClient
      .from('organisation_invite')
      .select('*, organisation(*)')
      .eq('invitee_email', email)
      .order('created_at', { ascending: false });
  },
} as const;
